import script from "./TrainingCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainingCalendar.vue?vue&type=script&setup=true&lang=js"

import "./TrainingCalendar.vue?vue&type=style&index=0&id=d19b1b7e&scoped=true&lang=css"
import "./TrainingCalendar.vue?vue&type=style&index=1&id=d19b1b7e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d19b1b7e"]])

export default __exports__